import React, { useCallback, useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import useLanguage from '@op/hooks/useLanguage';
import { useHotEventSummaryReport } from '../../hooks/useHotEventSummaryReport';
import { mdContentToHtml, replaceGptText } from '@op/utils/text';
import { useHotEventContext } from '../../context';
import { COMMENTS_SELECTOR, CommentsToggle, useCommentsToggleSimple } from '@op/components/GPT/components/CommentsToggle';
import './index.scss';
import { DBO_T } from '@op/utils/format';
import { DBO_POINT } from '@op/operationLog/buriedPoint';
import { copyIcon } from '@op/constants/chart';
import IconGemini from '@/pages/opinion/assets/svg/icon-gemini.png';

interface HotEventDetailProps {
  /** 隐藏评论的 CSS 类名 */
}

/**
 * 热门事件 - 详情(Summary)视图 (V2)
 * 使用 view_mode=summary 获取 GPT 摘要报告
 */
export default function HotEventDetail({
}: HotEventDetailProps) {
  const { formatMessage, isEn } = useLanguage();
  const { gameInfo, filter, sentimentValue, channelType, clusterCategoriesValue } = useHotEventContext();

  // 评论显示/隐藏切换
  const { showComments, setShowComments, hideClassName } = useCommentsToggleSimple(false);
  const { reportCn, reportEn, loading } = useHotEventSummaryReport(
    gameInfo,
    filter,
    sentimentValue,
    channelType,
    undefined,
    clusterCategoriesValue,
  );

  const reportText = isEn ? reportEn : reportCn;
  const isEmpty = !reportText && !loading;

  const reportHtml = useMemo(() => {
    if (!reportText) return null;
    const replacedText = replaceGptText(reportText);
    const { html } = mdContentToHtml(replacedText);
    return html;
  }, [reportText]);

  const handleCopy = useCallback(() => {
    if (!reportHtml) return;

    const div = document.createElement('div');
    div.innerHTML = reportHtml;

    // 与页面展示一致：隐藏评论时不复制评论列表
    if (hideClassName) {
      div.querySelectorAll(COMMENTS_SELECTOR).forEach(el => el.remove());
    }

    DBO_T.copy(div, formatMessage);
  }, [reportHtml, hideClassName, formatMessage]);

  return (
    <CardCommon
      className="dbo-summary-hot-event-detail"
      loading={loading}
      empty={isEmpty}
      emptyHeight={500}
      loadingHeight={500}
      operations={reportHtml ? [copyIcon] : []}
      handleOperationsOnClick={(item) => {
        if (item.symbol === "copy") {
          handleCopy();
        }
      }}
      title={
        <div className="dbo-summary-hot-event-detail-title">
          <img src={IconGemini} alt="" className="dbo-summary-hot-event-detail-title-icon" />
          <span className="dbo-summary-hot-event-detail-title-text">
            {formatMessage('AI Summary')}
          </span>
          <div className="dbo-summary-hot-event-detail-title-divider" />
          <CommentsToggle
            checked={showComments}
            onChange={(value) => {
              setShowComments(value);
              DBO_POINT.btn('HC_summaryFeedsChange', value);
            }}
          />
        </div>
      }
    >
      {/* {reportHtml && (
        <div className="dbo-summary-hot-event-detail-header">
          <SvgIcon
            type="copy-new"
            className="dbo-summary-hot-event-detail-header-icon"
            onClick={(e) => {

            }}
          />
        </div>
      )} */}
      {reportHtml && (
        <div
          className={`dbo-summary-hot-event-detail-content ${hideClassName}`}
          dangerouslySetInnerHTML={{ __html: reportHtml }}
        />
      )}
    </CardCommon>
  );
}
